module.exports = __webpack_public_path__ + "img/money.f5aaf8ab.svg";